import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { applicationListFetchByBusinessId, businessList } from '../../../recoil';
import { Applications } from './Applications/Applications';

export const MyApplication = () => {
  const { businessId } = useParams();
  const businessListDetails = useRecoilValue(businessList);
  const businessDetails = businessListDetails?.businesses.find(biz => biz.businessId === businessId);
  const appListDetails = useRecoilValue(applicationListFetchByBusinessId(businessId));
  const applicationList = appListDetails?.data?.applications;
  const businessNameForApp = businessDetails?.businessName;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const size = 33;
    const cameFromFinancial = sessionStorage.getItem('fromFinancial');

    if (!cameFromFinancial) {
      return undefined;
    }

    sessionStorage.removeItem('fromFinancial');
    navigate(location.pathname, { replace: true });

    for (let i = 0; i < size; i++) {
      try {
        window.history.pushState(null, '', window.location.href);
      } catch (err) {
        console.warn('pushState suppressed:', err.message);
      }
    }

    const handlePopState = (e) => {
      e.preventDefault();

      for (let i = 0; i < size; i++) {
        try {
          window.history.pushState(null, '', window.location.href);
        } catch (err) {
          console.warn('pushState suppressed:', err.message);
        }
      }

    };

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [navigate, location]);

  if ((applicationList && applicationList.length > 0) && businessNameForApp) {
    return <Applications listApplication={applicationList} businessNameForApp={businessNameForApp} />;
  }

  return null;
};